import { useAuthContext } from 'contexts/auth'
import { useInstitutionsContext } from 'contexts/institutions'
import { InstitutionsResponseDTO } from 'models'
import { useLocation } from 'react-router-dom'
import { institutionAll } from 'utils/fakeValues'

export const PATHS = {
    REPORT: 'relatorio'
} as const

export interface UseInstitutionsResult {
    institutionOptionAll: InstitutionsResponseDTO | null
    getInstitutionsList: () => InstitutionsResponseDTO[]
}

export const useInstitutions = (): UseInstitutionsResult => {
    const { isBackoffice } = useAuthContext()
    const { institutions } = useInstitutionsContext()
    const { pathname } = useLocation()

    const routesReport = pathname.includes(PATHS.REPORT)
    const routeNotification = pathname.includes('comunicacao')
    const shouldAddOptionAllInstitution =
        isBackoffice && (routesReport || routeNotification)
    const institutionOptionAll = shouldAddOptionAllInstitution
        ? institutionAll
        : null

    const getInstitutionsList = () => {
        if (!isBackoffice) {
            return institutions
        }

        return shouldAddOptionAllInstitution
            ? [institutionAll, ...institutions]
            : institutions
    }

    return {
        institutionOptionAll,
        getInstitutionsList
    }
}
